/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tea_Purchase_Payment_StatusInputs */

const vi_tea_purchase_payment_status = /** @type {(inputs: Tea_Purchase_Payment_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thanh toán`)
};

/**

* @param {Tea_Purchase_Payment_StatusInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const tea_purchase_payment_status = /** @type {((inputs?: Tea_Purchase_Payment_StatusInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tea_Purchase_Payment_StatusInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_tea_purchase_payment_status(inputs)
});